var _circle, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMyphoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#EEF1F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4286 23H28.5714C28.2558 23 28 23.2442 28 23.5455V34.4545C28 34.7558 28.2558 35 28.5714 35H43.4286C43.7442 35 44 34.7558 44 34.4545V23.5455C44 23.2442 43.7442 23 43.4286 23ZM32.8889 24.7143C33.6253 24.7143 34.2222 25.2899 34.2222 26C34.2222 26.7101 33.6253 27.2857 32.8889 27.2857C32.1525 27.2857 31.5556 26.7101 31.5556 26C31.5556 25.2899 32.1525 24.7143 32.8889 24.7143ZM42.162 32.1231C42.0647 32.3104 41.8627 32.429 41.6416 32.4286H31.2346C31.0122 32.428 30.8098 32.3071 30.7142 32.1177C30.6315 31.9373 30.658 31.729 30.7836 31.5722L33.0963 28.8449C33.1946 28.7285 33.3392 28.655 33.4965 28.6416C33.6537 28.6282 33.8099 28.676 33.9288 28.774L34.8655 29.5486L37.1319 26.6468C37.2411 26.5094 37.4124 26.4286 37.5944 26.4286C37.7754 26.4273 37.9466 26.506 38.057 26.6413L42.1042 31.5504C42.2373 31.7154 42.2597 31.9374 42.162 32.1231Z",
    fill: "#7783A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1784 45.67H21.8584V51.62H22.4984C23.4184 51.62 24.4784 51.57 25.6784 51.35L25.5684 50.24C24.6884 50.4 23.8984 50.46 23.1784 50.48V45.67ZM28.1284 44.64V48.19H27.2984V44.81H26.0684V53.42H27.2984V49.26H28.1284V53.85H29.3884V44.64H28.1284ZM36.3532 45.36H35.0232V46.7C35.0232 48.41 34.3232 50.17 32.7732 50.9L33.5632 51.97C34.6032 51.46 35.2932 50.49 35.6932 49.32C36.0732 50.42 36.7232 51.31 37.6832 51.8L38.4832 50.76C37.0032 50.03 36.3532 48.36 36.3532 46.7V45.36ZM41.5132 48.19H40.1732V44.65H38.8532V53.86H40.1732V49.29H41.5132V48.19ZM49.8124 44.65H48.4824V51.31H49.8124V44.65ZM47.9024 49.16C46.4124 48.67 45.7424 47.54 45.7424 46.46V46.35H47.5624V45.31H42.5524V46.35H44.4024V46.46C44.4024 47.61 43.7324 48.82 42.2024 49.3L42.8724 50.33C43.9424 49.98 44.6824 49.27 45.0924 48.37C45.5124 49.19 46.2124 49.85 47.2324 50.17L47.9024 49.16ZM45.0024 52.65V50.71H43.6824V53.7H50.0424V52.65H45.0024Z",
    fill: "#7783A1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyphoto);
export default __webpack_public_path__ + "static/media/myphoto.c8bea0e55fe0b8e7cbd1e693dbb80fd0.svg";
export { ForwardRef as ReactComponent };